import { render } from "./MngInventory.vue?vue&type=template&id=3e5d083b&scoped=true&ts=true"
import script from "./MngInventory.vue?vue&type=script&lang=ts"
export * from "./MngInventory.vue?vue&type=script&lang=ts"

import "./MngInventory.vue?vue&type=style&index=0&id=3e5d083b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5d083b"]])

export default __exports__